import { getHttpClient } from '../core/httpClient';
import type { EventInfo, CheckoutResponse, Customer, PublicOrder, UpdateOrderResponse, UpdateOrderLineItem, UTMParams } from '../types';

export class CartService {
  async addTicket(
    eventId: string, 
    eventInfo: Omit<EventInfo, 'zoneName' | 'zoneNameEs' | 'menuName' | 'menuNameEs'>, 
    quantity: number,
    utm?: UTMParams
  ): Promise<string | null> {
    const client = getHttpClient();
    return client.post<string>('/public/cart/add-ticket', {
      eventId,
      eventInfo,
      quantity,
      utm,
    });
  }

  async addProduct(productId: string, quantity: number): Promise<string | null> {
    const client = getHttpClient();
    return client.post<string>('/public/cart/add-product', {
      productId,
      quantity,
    });
  }

  async validateCode(eventId: string, date: string, timeSlot: string, code: string): Promise<{ valid: boolean; percentage: number; remainingUses: number }> {
    const client = getHttpClient();
    return client.post('/public/cart/validate-code', {
      eventId,
      date,
      timeSlot,
      code,
    });
  }
  
  async checkout(orderId: string, customer: Customer, language?: string, discountCode?: string): Promise<CheckoutResponse> {
    const client = getHttpClient();
    return client.post<CheckoutResponse>('/public/cart/checkout', {
      orderId,
      customer,
      language,
      discountCode,
    });
  }

  async update(orderId: string, orderLines: UpdateOrderLineItem[]): Promise<UpdateOrderResponse> {
    const client = getHttpClient();
    return client.put<UpdateOrderResponse>(`/public/cart/${orderId}/update`, orderLines);
  }

  async get(orderId: string, authToken: string): Promise<PublicOrder> {
    const client = getHttpClient();
    return client.get<PublicOrder>(`/public/cart/${orderId}`, {
      headers: {
        'Authorization': `Bearer ${authToken}`
      }
    });
  }
}

export const cartService = new CartService();
